import { TH } from '../lib/theme';

const fileLabel = f => f ? f.name : 'No file selected';

export function StackImportSheet({ show, files, setFiles, plan, parseError, onParse, onConfirm, onClose, dm }) {
  if (!show) return null;
  const T = TH(dm);
  const fileRow = (key, label, required) => (
    <div style={{ marginBottom: 10 }}>
      <label style={{ display: 'block', padding: '10px 12px', border: `1px solid ${T.BORDER}`, borderRadius: 10, cursor: 'pointer', fontSize: 12, fontFamily: 'monospace', color: T.TEXT }}>
        {label}{required ? ' *' : ''} — <span style={{ color: T.DIM }}>{fileLabel(files[key])}</span>
        <input type="file" accept=".csv" style={{ display: 'none' }}
          onChange={e => setFiles(prev => ({ ...prev, [key]: e.target.files?.[0] || null }))} />
      </label>
    </div>
  );

  return (
    <div data-testid="stack-import-sheet" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ width: '90%', maxWidth: 500, backgroundColor: dm ? '#0a0e12' : '#ffffff', border: `1px solid ${T.BORDER}`, borderRadius: 12, padding: '16px 20px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column', gap: 14, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ fontSize: 10, fontFamily: 'monospace', fontWeight: 600, letterSpacing: '0.12em', color: T.TEXT, textTransform: 'uppercase' }}>Import Stack from Spreadsheet</div>

        {!plan && <>
          {fileRow('stackItems', 'Stack Items CSV', true)}
          {fileRow('injectableVials', 'Injectable Vials CSV', false)}
          {fileRow('pillBottles', 'Pill & Pen Bottles CSV', false)}
          {parseError && <div style={{ fontSize: 11, fontFamily: 'monospace', color: '#e84040', padding: '8px 12px', background: 'rgba(232,80,80,0.08)', borderRadius: 8 }}>{parseError}</div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" onClick={onParse} style={{ flex: 1, padding: '11px', borderRadius: 8, fontSize: 13, fontWeight: 600, border: 'none', backgroundColor: '#4ab868', color: '#000', cursor: 'pointer' }}>Preview</button>
            <button type="button" onClick={onClose} style={{ flex: 1, padding: '11px', borderRadius: 8, fontSize: 13, fontWeight: 600, border: `2px solid ${T.BORDER}`, backgroundColor: 'transparent', color: T.TEXT, cursor: 'pointer' }}>Cancel</button>
          </div>
        </>}

        {plan && <>
          <div style={{ fontSize: 12, fontFamily: 'monospace', color: T.TEXT }}>
            {plan.summary.compounds} stack item{plan.summary.compounds === 1 ? '' : 's'}, {plan.summary.vials} vial/bottle{plan.summary.vials === 1 ? '' : 's'} will be created.
          </div>
          {plan.errors.length > 0 && <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div style={{ fontSize: 10, fontFamily: 'monospace', color: '#e84040', letterSpacing: '0.08em' }}>{plan.errors.length} ROW{plan.errors.length === 1 ? '' : 'S'} SKIPPED</div>
            {plan.errors.map((e, i) => (
              <div key={i} style={{ fontSize: 11, fontFamily: 'monospace', color: '#e84040', padding: '6px 10px', background: 'rgba(232,80,80,0.08)', borderRadius: 6 }}>
                {e.tab} — Row {e.row}: {e.reason}
              </div>
            ))}
          </div>}
          <div style={{ display: 'flex', gap: 8 }}>
            <button type="button" onClick={onConfirm} disabled={plan.summary.compounds === 0 && plan.summary.vials === 0}
              style={{ flex: 1, padding: '11px', borderRadius: 8, fontSize: 13, fontWeight: 600, border: 'none', backgroundColor: (plan.summary.compounds === 0 && plan.summary.vials === 0) ? (dm ? '#1a3a3a' : '#d0d0d0') : '#4ab868', color: (plan.summary.compounds === 0 && plan.summary.vials === 0) ? (dm ? '#4a6a6a' : '#808080') : '#000', cursor: (plan.summary.compounds === 0 && plan.summary.vials === 0) ? 'not-allowed' : 'pointer' }}>Confirm Import</button>
            <button type="button" onClick={onClose} style={{ flex: 1, padding: '11px', borderRadius: 8, fontSize: 13, fontWeight: 600, border: `2px solid ${T.BORDER}`, backgroundColor: 'transparent', color: T.TEXT, cursor: 'pointer' }}>Cancel</button>
          </div>
        </>}
      </div>
    </div>
  );
}
